import { render } from "./ConsentItem.vue?vue&type=template&id=e466a0fe&scoped=true"
import script from "./ConsentItem.vue?vue&type=script&lang=js"
export * from "./ConsentItem.vue?vue&type=script&lang=js"

import "./ConsentItem.vue?vue&type=style&index=0&id=e466a0fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e466a0fe"]])

export default __exports__